import React, {Component, PropTypes} from 'react';
import TreeView from 'react-treeview';
import {
  Icon,
  Label,
} from '@sketchpixy/rubix';

import FileType from './FileType';

class FileTree extends Component {
  onTreeClick(index) {
    let tree = this.props.tree;
    tree[index].collapsed = !tree[index].collapsed;

    this.setState({tree});
  };

  onClickNode(node) {
    this.props.onClickNode(node);
  }

  render() {
    function getLocaleCode(language, region) {
      if (language === null && region === null) {
        return null;
      } else if (language === null) {
        return `any_${region}`;
      } else if (region === null) {
        return `${language}_any`;
      } else {
        return `${language}_${region}`;
      }
    }

    return (
        <div>
          {
            this.props.tree.map((node, index) => {
              if (node.type === FileType.DIRECTORY) {
                const label = (
                    <span className="node" style={{cursor: 'pointer'}} onClick={this.onClickNode.bind(this, node)}>
                      <Icon bundle='stroke-gap-icons' glyph='Folder' className='fg-desaturateddarkblue' />
                      &nbsp;{node.name}
                    </span>
                );
                const key = JSON.stringify({
                  name: node.name,
                  index: index,
                });
                return (
                    <TreeView
                        key={key}
                        nodeLabel={label}
                        collapsed={node.collapsed}
                        onClick={this.onTreeClick.bind(this, index)}
                    >
                      {
                        node.children ? (
                            <FileTree
                                tree={node.children}
                                currentAssetVersionId={this.props.currentAssetVersionId}
                                onClickNode={this.props.onClickNode}
                            />
                        ) : <span />
                      }
                    </TreeView>
                );
              }
            })
          }
          {
            this.props.tree.map((node, i) => {
              if (node.type === FileType.FILE) {
                return (
                    <div
                        className="info"
                        key={`${node.assetNAssetVersionId}_${node.language}_${node.region}_${node.name}`}
                    >
                      <span className="node">
                        <a href="#" onClick={this.onClickNode.bind(this, node)}>
                          <Icon bundle='stroke-gap-icons' glyph='File' className='fg-desaturateddarkblue' />
                          &nbsp;{node.name}
                          <Label className='bg-deepred fg-white' style={{marginLeft: 5}}>
                            {
                              getLocaleCode(node.language, node.region)
                            }
                          </Label>
                        </a>
                      </span>
                    </div>
                );
              }
            })
          }
        </div>
    );
  }
}

FileTree.propTypes = {
  tree: PropTypes.array.isRequired,
  currentAssetVersionId: PropTypes.number.isRequired,
  onClickNode: PropTypes.func.isRequired,
};

export default FileTree;



// WEBPACK FOOTER //
// ./src/routes/asset/FileTree.js